import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { startLoadingActionsMeta } from '../../actions/action';
import buildMiddleware from './template';
const withActionsMetaFetch = SubComponent => {
  const WithActionsMetaFetchWrapper = buildMiddleware(SubComponent, 'WithActionsMeta');
  const WithActionsMetaFetch = class extends Component {
    componentDidMount() {
      this.props.startLoadingActionsMeta();
    }
    render() {
      const {
        startLoadingActionsMeta,
        ...passThroughProps
      } = this.props;
      return /*#__PURE__*/React.createElement(WithActionsMetaFetchWrapper, passThroughProps);
    }
  };
  const mapStateToProps = _ref => {
    let {
      action
    } = _ref;
    return {
      loading: action.actionsMetaLoading || !action.actionsMeta && !action.actionsMetaError,
      error: action.actionsMetaError
    };
  };
  const mapDispatchToProps = dispatch => ({
    startLoadingActionsMeta: () => dispatch(startLoadingActionsMeta())
  });
  WithActionsMetaFetch.propTypes = {
    startLoadingActionsMeta: PropTypes.func.isRequired
  };
  return connect(mapStateToProps, mapDispatchToProps)(WithActionsMetaFetch);
};
export default withActionsMetaFetch;